import Modal from "components/Modal/Modal";
import { useState } from "react";
import { toast } from "react-toastify";
import { commonService } from "Dashboard/services/common.service";

interface IProps {
  isOpen: boolean;
  setIsOpen: Function;
}

const SpreadsheetLoaderModal = ({ isOpen, setIsOpen }: IProps) => {
  const [excelFile, setExcelFile] = useState(null);

  const handleFile = (e: any) => {
    const fileTypes = [
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "text/csv"];
    let selectedFile = e.target.files[0];

    if (selectedFile) {
      if (selectedFile && fileTypes.includes(selectedFile.type)) {
        setExcelFile(selectedFile);
      }
      else {
        toast.error("Selektovani fajl mora biti u excel formatu.");
      }
    }
    else {
      console.log("Please select your file.");
    }
  };

  const closeDialog = () => {
    setIsOpen(false);
    setExcelFile(null);
  };

  const uploadFile = async () => {
    try {
      if (excelFile) {
        const response = await commonService.uploadExcelFile(excelFile);

        if (response && response.message === "success") {
          closeDialog();
          toast.success("Excel file je uspešno uploadovan.");
        } else {
          toast.error("Došlo je do greške prilikom uploada! Pokušajte ponovo.");
        }
      }
    } catch (e) {
      toast.error("Došlo je do greške prilikom uploada! Pokušajte ponovo.");
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      title="Upload excel file"
      onClose={closeDialog}
      onClick={excelFile ? uploadFile : undefined}
    >
      <>
        <div>Selektujte odgovarajući excel file.</div>
        <input type="file" onChange={handleFile} accept=".xls,.xlsx" />
      </>
    </Modal>
  );
};

export default SpreadsheetLoaderModal;
